import { readNumber } from './numberText';

/**
 * A limit from the row edit form or the stored range. Empty means empty text,
 * null or undefined: no limit. 0 is a limit ("0 - 5" keeps its 0). Text is read
 * like the backend reads it ("11,000" is 11000; an ambiguous "5,5" is no number).
 */
export function readLimit(input: unknown): number | null {
  if (input === null || input === undefined) return null;
  if (typeof input === 'string' && input.trim() === '') return null;
  return readNumber(input).number;
}

export interface ReferenceRangeValue {
  low: number | null;
  high: number | null;
  referenceRange: string;
}

/**
 * The referenceRange to save after a row edit, or null when the nurse did not
 * change the range (so editing the value or unit never rewrites the limits).
 */
export function referenceRangeChange(
  current: { low: number | null; high: number | null; text: string },
  edited: { low: unknown; high: unknown; text: unknown }
): ReferenceRangeValue | null {
  const low = readLimit(edited.low);
  const high = readLimit(edited.high);
  const text = typeof edited.text === 'string' ? edited.text : '';
  if (low === current.low && high === current.high && text === current.text) return null;
  return { low, high, referenceRange: text };
}
